import { render } from "./colordeojos.vue?vue&type=template&id=69507eb8"
import script from "./colordeojos.vue?vue&type=script&lang=js"
export * from "./colordeojos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__